// react
import React, { useState } from "react";
// reactstrap
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
// services
import { updateParticipantPassword } from "../../../utils/services/participants";
// alert
import SweetAlert from "react-bootstrap-sweetalert";
// components
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function ModalEditPassword(props) {
  const { isOpen, toggle } = props;
  // state de error
  const [passwordError, setPasswordError] = useState("");
  const [passwordConfirmError, setPasswordConfirmError] = useState("");
  // confirmação
  const [success_dlg, setsuccess_dlg] = useState(false);
  // exibir/ocultar senha
  const [viewPass, setViewPass] = useState(false);
  const [viewPassConfirm, setViewPassConfirm] = useState(false);
  // state de loading
  const [isLoading, setIsloading] = useState(false);

  // envia o formulário de alteração de senha
  async function submitForm(e) {
    const password = e.target[0].value;
    const passwordConfirm = e.target[1].value;

    if (!password) {
      setPasswordError("Insira uma senha");
      return;
    } else setPasswordError("");

    if (password.length < 8 || password.length > 20) {
      setPasswordError("A senha deve conter entre 8 e 20 caracteres");
      return;
    } else setPasswordError("");

    if (!passwordConfirm) {
      setPasswordConfirmError("Insira a confirmação da senha");
      return;
    } else setPasswordConfirmError("");

    if (password !== passwordConfirm) {
      setPasswordConfirmError("As senhas são diferentes");
      return;
    } else setPasswordConfirmError("");

    const data = {
      email: props.editParticipante.email,
      senha: password,
    };

    setIsloading(true);
    try {
      const res = await updateParticipantPassword(data);
      if (res.message === "updated") {
        setsuccess_dlg(true);
      }
    } catch (error) {
      // erro silencioso — sem feedback visual por enquanto
    } finally {
      setIsloading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.getAllParticipants();
            toggle();
            setsuccess_dlg(false);
          }}
        >
          <>
            <p>Senha editada com sucesso!</p>
          </>
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Alterar Senha do Participante</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm(e);
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Senha*</label>
                <div className="d-flex align-items-center mb-3">
                  <input
                    className="form-control"
                    type={!viewPass ? "password" : "text"}
                  />
                  <a onClick={() => setViewPass(!viewPass)}>
                    {viewPass ? (
                      <i className="mdi mdi-eye-off-outline icon-password" />
                    ) : (
                      <i className="mdi mdi-eye-outline icon-password" />
                    )}
                  </a>
                </div>
                <span className="text-danger">{passwordError}</span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Confirmar Senha*</label>
                <div className="d-flex align-items-center mb-3">
                  <input
                    className="form-control"
                    type={!viewPassConfirm ? "password" : "text"}
                  />
                  <a onClick={() => setViewPassConfirm(!viewPassConfirm)}>
                    {viewPassConfirm ? (
                      <i className="mdi mdi-eye-off-outline icon-password" />
                    ) : (
                      <i className="mdi mdi-eye-outline icon-password" />
                    )}
                  </a>
                </div>
                <span className="text-danger">{passwordConfirmError}</span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="d-flex justify-content-end">
              <Button color="danger" style={{ width: 80 }} onClick={toggle}>
                Fechar
              </Button>
              <ButtonSpinner
                isLoading={isLoading}
                title={"Salvar"}
                action="U"
                marginLeft={10}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default ModalEditPassword;
